/**
 * PositSearchBar.tsx
 * 
 * Search bar component for the Posits listing.
 * Extracted from MyPosits.tsx to improve modularity and reusability.
 */

import React from "react";
import { Search, X } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

interface PositSearchBarProps {
  searchQuery: string;
  setSearchQuery: (value: string) => void;
  onSearch: (e: React.FormEvent) => void;
}

const PositSearchBar: React.FC<PositSearchBarProps> = ({
  searchQuery,
  setSearchQuery,
  onSearch,
}) => {
  const handleClearSearch = () => {
    setSearchQuery("");
  };

  return (
    <form onSubmit={onSearch} className="relative">
      <Search className="absolute left-2 top-2.5 h-4 w-4 text-muted-foreground" />
      <Input
        placeholder="Search posits..."
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        className="pl-8 h-9"
      />
      {searchQuery && (
        <Button
          type="button"
          variant="ghost"
          onClick={handleClearSearch}
          className="absolute right-0 top-0 h-9 w-9 p-0"
        >
          <X className="h-4 w-4" />
          <span className="sr-only">Clear search</span>
        </Button>
      )}
    </form>
  );
};

export default PositSearchBar; 